export const SCHEDULE_DRAFT_AGENT_NAME = "SCHEDULE_DRAFT_OPTIMIZER";
export const AGENT_TRACK_TYPE = "AGENT";
export const AGENT_STATUS_LABELS = {
    PENDING: "等待中",
    PROCESSING: "处理中",
    RUNNING: "执行中",
    COMPLETED: "已完成",
    PASSED: "已通过",
    SUCCESS: "已完成",
    FAILED: "失败",
    ERROR: "异常",
    TIMEOUT: "超时",
    UNKNOWN: "Agent 状态待同步",
};

export function getAgentContext(track) {
    return track?.agent_context && typeof track.agent_context === "object" ? track.agent_context : {};
}

export function isAgentTrack(track) {
    return track?.track_type === AGENT_TRACK_TYPE || Boolean(track?.agent_context);
}

export function getAgentTrackStatus(track) {
    const context = getAgentContext(track);
    if (context.status) {
        return String(context.status).toUpperCase();
    }
    if (track?.evaluation) {
        return "COMPLETED";
    }
    return isAgentTrack(track) ? "RUNNING" : null;
}

export function isAgentTrackRunning(track) {
    return ["RUNNING", "PENDING", "PROCESSING"].includes(getAgentTrackStatus(track));
}

export function getAgentStatusLabel(status) {
    const normalizedStatus = String(status || "UNKNOWN").toUpperCase();
    return AGENT_STATUS_LABELS[normalizedStatus] || AGENT_STATUS_LABELS.UNKNOWN;
}

export function getAgentAircraftReg(track) {
    const context = getAgentContext(track);
    return context.aircraft_reg || null;
}

export function getAgentStrategyLabel(track) {
    const context = getAgentContext(track);
    return context.strategy_label || context.strategy || context.label || `strategy-${context.strategy_prompt_id || track?.name || "agent"}`;
}

export function getAgentTrackDisplayLabel(track) {
    const aircraftReg = getAgentAircraftReg(track) || "未指定飞机";
    return `${aircraftReg} · ${getAgentStrategyLabel(track)}`;
}

export function getAgentRoundLabel(track) {
    const context = getAgentContext(track);
    const explicitLabel = context.agent_round_label || context.round_label || context.agent_round || context.round || context.ag_request_id || context.ag_run_id;
    if (explicitLabel) {
        return String(explicitLabel);
    }

    return track?.name || "AI 轮次";
}

export function getAgentEvaluationSummary(track) {
    const evaluation = track?.evaluation;
    const status = getAgentTrackStatus(track);

    if (isAgentTrackRunning(track)) {
        return "Agent 执行中";
    }
    if (!evaluation) {
        return status ? getAgentStatusLabel(status) : "暂无评价";
    }

    const evaluationStatus = evaluation.status || status || "UNKNOWN";
    const violationCount = evaluation.hard_violation_count ?? evaluation.violation_count ?? 0;
    return `${getAgentStatusLabel(evaluationStatus)} · ${violationCount} 违规`;
}

export function getAgentStatusTone(status) {
    const normalizedStatus = String(status || "").toUpperCase();
    if (["COMPLETED", "PASSED", "SUCCESS"].includes(normalizedStatus)) {
        return "success";
    }
    if (["FAILED", "ERROR", "TIMEOUT"].includes(normalizedStatus)) {
        return "error";
    }
    if (["RUNNING", "PROCESSING", "PENDING"].includes(normalizedStatus)) {
        return "processing";
    }
    return "default";
}

export function getAgentTrackIds(tracks = []) {
    return tracks.filter(isAgentTrack).map((track) => track.id).filter(Boolean);
}

export function getScenarioStrategyLabel(strategy) {
    const conditions = strategy?.scenario_conditions && typeof strategy.scenario_conditions === "object" ? strategy.scenario_conditions : {};
    return conditions.strategy_label || conditions.label || conditions.strategy || conditions.name || conditions.code || strategy?.description || `strategy-${strategy?.id}`;
}
